import { render, staticRenderFns } from "./KeyboardRepair.vue?vue&type=template&id=74db6456&scoped=true&"
import script from "./KeyboardRepair.vue?vue&type=script&lang=js&"
export * from "./KeyboardRepair.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardRepair.vue?vue&type=style&index=0&id=74db6456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74db6456",
  null
  
)

export default component.exports